import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getUnprocessedItems, getOutstandingTotal } from 'helpers/accounting';
import Badge from 'components/v2/Badge';
import { withTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import { Disclosure } from '@headlessui/react';
import { ChevronRightIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import { featureEnabled, CONFIGURED_FEATURES } from 'helpers/feature-flags';
class ChargeItem extends Component {
    constructor(props) {
        super(props);
        this.handleToggleExpand = () => {
            this.setState((prevState) => ({ expanded: !prevState.expanded }));
        };
        this.state = { expanded: false };
    }
    getOutstandingTotal() {
        const { ledgerType, shipment } = this.props;
        return getOutstandingTotal(shipment, ledgerType);
    }
    getFormattedTotal() {
        const amount = this.getOutstandingTotal();
        return formatMoney(amount, this.props.currency);
    }
    render() {
        const { shipment, isEven, t } = this.props;
        const { expanded } = this.state;
        const missingDocsLabel = featureEnabled(CONFIGURED_FEATURES.SSR) ? 'MISSING_DOCS' : 'MISSING_POD';
        const className = classnames({
            'w-full': true,
            'flex-col': true,
            flex: true,
            'text-grey-dark': true,
            'bg-white': !isEven,
            'bg-grey-lightest': isEven,
            'px-2': true,
        });
        const headingClassName = classnames({
            'w-1/2': true,
            'font-bold': true,
            'text-grey-darker': true,
            flex: true,
        });
        return (React.createElement(Disclosure, null,
            React.createElement("div", { className: className },
                React.createElement("div", { className: "w-full flex flex-row items-center" },
                    React.createElement("div", { className: headingClassName },
                        React.createElement("span", null, shipment.shipment_id),
                        shipment.missing_docs && (React.createElement("div", { className: "px-2 -mt-0.5" },
                            React.createElement(Badge, { color: "red" }, t(missingDocsLabel))))),
                    React.createElement("div", { className: "w-1/4 flex lg:justify-end" },
                        React.createElement("div", { className: "w-1/2 md:pl-6" }, !this.state.expanded && (React.createElement("span", null, this.getFormattedTotal())))),
                    React.createElement("div", { className: "w-1/4 flex items-center lg:justify-end" },
                        React.createElement(Disclosure.Button, { className: "button justify-center flex items-center px-0 m-1" }, ({ open }) => (React.createElement(React.Fragment, null,
                            !open && React.createElement(ChevronRightIcon, { className: "w-5 h-5" }),
                            open && React.createElement(ChevronUpIcon, { className: "w-5 h-5" })))))),
                React.createElement(Disclosure.Panel, null,
                    React.createElement(Charges, Object.assign({}, this.props),
                        React.createElement("div", { className: "w-full flex justify-between mb-2" },
                            React.createElement("span", { className: "font-bold mr-2" },
                                t('TOTAL'),
                                ":"),
                            React.createElement("span", null, this.getFormattedTotal())))))));
    }
}
ChargeItem.propTypes = {
    shipment: PropTypes.object,
    isEven: PropTypes.bool,
    ledgerType: PropTypes.oneOf(['receivables', 'payables']),
};
const Charges = ({ children, shipment, ledgerType, expanded, currency }) => (React.createElement("div", { className: "w-full" },
    React.createElement("div", { className: "charges-wrapper mb-4" },
        React.createElement("div", { className: "bg-white p-2" },
            getUnprocessedItems(shipment, ledgerType).map((adjustment) => (React.createElement("div", { key: adjustment._id, className: "w-full flex flex-row justify-between my-2 mb-2" },
                React.createElement("div", null, adjustment.message),
                React.createElement("div", null, formatMoney(adjustment.value, currency))))),
            React.createElement("hr", { className: "my-2" }),
            children))));
Charges.propTypes = {
    expanded: PropTypes.bool,
    shipment: PropTypes.object,
    children: PropTypes.node,
    ledgerType: PropTypes.oneOf(['receivables', 'payables']),
};
export default withTranslation()(ChargeItem);
